module.exports = ReactBootstrap;


//////////////////
// WEBPACK FOOTER
// external "ReactBootstrap"
// module id = 18
// module chunks = 0